$(() => {
    // Verifica hash ao iniciar
    // URI.init();

    (<any>$('#p5fw-accessibility-buttons')).p5fwAccessibility();

    $('.s-w-btn, .s-s-w-btn').click(function () {
        const element = $(this)[0];

        e = $.Event('keyup');
        e.keyCode = 13; // enter
        if ($(element).hasClass('s-w-btn')) {
            $('#service-search').trigger(e);
        } else {
            $('#s-service-search').trigger(e);
        }
    });

    $('#button-download-pdf').click(function () {
        var data = {
            action: 'servicos_print',
        };

        $('#button-download-pdf').addClass('d-none');
        $('#button-loading').removeClass('d-none');
        $.post('/load', data, function (r) {
            $('#button-loading').addClass('d-none');
            $('#button-download-pdf').removeClass('d-none');
            var newWin = document.getElementById('servicos-print-iframe').contentWindow;
            newWin.document.write(r);
            newWin.document.close(); //important!
            newWin.focus(); //IE fix
            document.getElementById('servicos-print-iframe').style.display = 'block';
            newWin.print();
            document.getElementById('servicos-print-iframe').style.display = 'none';
        });
    });

    $('#service-search, #s-service-search').keyup(function (event: any) {
        const element = $(this)[0].id;

        if (event.keyCode == 13) {
            let search: string = $(`#${element}`).val().toString();
            let tipoId: number = $('input[name="tipoid"]:checked');
            console.log(tipoId);

            var action: string = 'search';
            var data = {
                action: null,
                ref: null,
                search: null,
            };

            data.action = action;
            data.search = search;

            $('#servico-details').html('').addClass('p5-ajax-loader');
            $.post('/load', data, function (r) {
                $('#servico-details').removeClass('p5-ajax-loader').html(r);
            });
        }
    });

    $('#categoria-selecionada').on('change', function () {
        let tipoLink: string = $('#tipolink').val();
        let categoriaId = $(this).find(':selected').val();
        let categoriaName: string = $(this).find(':selected').data('name');

        window.location.href = `/index/categoria/t/${tipoLink}/c/${categoriaId}/${categoriaName}`;
    });
});
